import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RepatriationsTransactionsConfirmDialog from './RepatriationsTransactionsConfirmDialog';

class RepatriationsTransactionsConfirm extends Component {
  render() {
    return (
      <div>
        <RepatriationsTransactionsConfirmDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

RepatriationsTransactionsConfirm.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default RepatriationsTransactionsConfirm;
